const items = document.querySelectorAll( '.item' );
 
const isFloat = ( n ) => {
  return Number( n ) === n && n % 1 !== 0;
}
 
const getDecimalPointLength =( n ) => {
  return ( String( n ).split( '.' )[1] || '' ).length;
}
 
const observeAction = ( entries ) => {
  entries.forEach( entry => {
    if ( entry.isIntersecting ) {
      if ( ! entry.target.classList.contains( 'is-visible' ) ) {
        const counterEle = entry.target.querySelector( '.counter .number' );
        const from = parseFloat( entry.target.dataset.from || 0 );
        const to = parseFloat( entry.target.dataset.to || 0 );
        const duration = parseInt( entry.target.dataset.duration ) || 1500;
 
        if ( !Number.isFinite( from ) || !Number.isFinite( to ) || from > to ) {
          return false;
        }
 
        const increment = to - from;
        const deciamlPointLength = getDecimalPointLength( increment );
        const startTime = performance.now();
 
        const countUp = ( timestamp ) => {
          const elapsed = performance.now() - startTime;
          const countValue = ( from + ( ( elapsed / duration ) * increment ) ).toFixed( deciamlPointLength );
 
          if ( countValue >= to ) {
            counterEle.innerText = to.toLocaleString();
          } else {
            counterEle.innerText = parseFloat( countValue ).toLocaleString();
            requestAnimationFrame( countUp );
          }
        }
        
        requestAnimationFrame( countUp );
 
        // entry.target.classList.add( 'is-visible' ); 
      }
    }
  } );
}
 
const options = {
  threshold: 1,
}
 
const obsever = new IntersectionObserver( observeAction, options );
 
items.forEach( target => {
  obsever.observe( target );
} );

// 要素が画面内に入ったらclass付与
$(window).scroll(function () {
  $('.pi-graph').each(function () {
    var hit = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var wHeight = $(window).height();
    var customTop = 100;
    if (typeof $(this).data('pi-graph') !== 'undefined') {
      // data-effect="任意の値" が設定されている場合
      customTop = $(this).data('pi-graph');
    }
    if (hit + customTop < wHeight + scroll) {
      $(this).addClass("pi-active");
    }
  });
});

$(window).scroll(function () {
  $('.smooth-blur').each(function () {
    var hit = $(this).offset().top;
    var scroll = $(window).scrollTop();
    var wHeight = $(window).height();
    var customTop = 100;
    if (typeof $(this).data('smooth-blur') !== 'undefined') {
      // data-effect="任意の値" が設定されている場合
      customTop = $(this).data('smooth-blur');
    }
    if (hit + customTop < wHeight + scroll) {
      $(this).addClass("smooth-blur-active");
    }
  });
});

MicroModal.init({
  disableScroll: false // モーダルが開いている間に、背景スクロールを無効にする。 
}); 
// モーダルを開く
MicroModal.show('modal-o');
// モーダルを閉じる
MicroModal.close('modal-o');

const pauseVideo = () => {
  document.querySelector("video").pause();
};

MicroModal.init({
  awaitCloseAnimation: true,
  awaitOpenAnimation: true,
  onClose: pauseVideo
});